import { render } from "./RowDetailsModal.vue?vue&type=template&id=18de8290&scoped=true&ts=true"
import script from "./RowDetailsModal.vue?vue&type=script&lang=ts"
export * from "./RowDetailsModal.vue?vue&type=script&lang=ts"

import "./RowDetailsModal.vue?vue&type=style&index=0&id=18de8290&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18de8290"]])

export default __exports__